import React from 'react';
import { useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import Checkbox from '@material-ui/core/Checkbox';
import { isNotEmptyOrNull } from '@tecsinapse/es-utils/build';
import RowActions from '../RowActions/RowActions';
import { resolveData } from '../../utils/tableFunctions';

var isSelected = function isSelected(selectedRows, row, rowId) {
  return isNotEmptyOrNull(selectedRows) && selectedRows.some(function (selectedRow) {
    return rowId(selectedRow) === rowId(row);
  });
};

var convertValuesToTableCell = function convertValuesToTableCell(_ref, rowData, rowId, selectedRows, forceCollapseActions, verticalActions, theme) {
  var field = _ref.field,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options,
      selection = _ref.selection,
      actions = _ref.actions,
      customRender = _ref.customRender;
  var _options$visible = options.visible,
      visible = _options$visible === void 0 ? true : _options$visible;

  if (!visible) {
    return null;
  }

  if (selection) {
    return /*#__PURE__*/React.createElement(TableCell, {
      key: field,
      padding: "checkbox"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: isSelected(selectedRows, rowData, rowId)
    }));
  }

  if (actions) {
    var style = {
      paddingRight: theme.spacing(1),
      width: forceCollapseActions || actions.length >= 4 ? '50px' : "".concat(actions.length * 50, "px"),
      paddingTop: 0,
      paddingBottom: 0
    };
    return /*#__PURE__*/React.createElement(TableCell, {
      key: field,
      align: "right",
      style: style
    }, /*#__PURE__*/React.createElement(RowActions, {
      actions: actions,
      row: rowData,
      rowId: rowId,
      verticalActions: verticalActions,
      forceCollapseActions: forceCollapseActions
    }));
  }

  return /*#__PURE__*/React.createElement(TableCell, {
    key: field,
    align: options.numeric ? 'right' : 'left'
  }, customRender ? customRender(rowData) : resolveData(field, rowData));
};

export var Cells = function Cells(_ref2) {
  var columns = _ref2.columns,
      rowData = _ref2.rowData,
      rowId = _ref2.rowId,
      selectedRows = _ref2.selectedRows,
      forceCollapseActions = _ref2.forceCollapseActions,
      verticalActions = _ref2.verticalActions;
  var theme = useTheme();
  return columns.map(function (column) {
    return convertValuesToTableCell(column, rowData, rowId, selectedRows, forceCollapseActions, verticalActions, theme);
  });
};
Cells.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowData: PropTypes.object.isRequired,
  rowId: PropTypes.func.isRequired,
  selectedRows: PropTypes.arrayOf(PropTypes.object),
  forceCollapseActions: PropTypes.bool
};